import React from 'react';
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import dataCard from '../assets/fake-data/data-card';
import dataPartners from '../assets/fake-data/data-partners';
import dataPortfolio from '../assets/fake-data/data-portfolio';
import dataRoadMap from '../assets/fake-data/data-roadmap';
import About from '../components/layouts/About';
import Action from '../components/layouts/Action';
import Partners from '../components/layouts/Partners';
import Portfolio from '../components/layouts/Portfolio';
import RoadMap from '../components/layouts/RoadMap';
import Speciality from '../components/layouts/Speciality';
import SliderOne from '../components/slider/SliderOne';

const Home01 = () => {
    return (
        <div>
            <Header />
            <SliderOne />
            <Speciality data={dataCard} />
            <About />
            <Partners data={dataPartners} />
            <Portfolio data={dataPortfolio} />
            <RoadMap data={dataRoadMap} />
            <Action />
            <Footer />
        </div>
    );
}

export default Home01;